// extracted by mini-css-extract-plugin
module.exports = {"ModalOtpContainer":"ModalOtpVerification_ModalOtpContainer__2pFaL","ModalOtpTitle":"ModalOtpVerification_ModalOtpTitle__2wCH_"};